
define('models/session',['models/user', 'plugins/jquery/cookie', 'lib/sjcl'], function(UserModel) {

	return Backbone.Model.extend({

		url: 'session',
		
		logout: function() {
			var user = this.getHttpCookie();
			
			$.removeCookie(this.getCookieName(), {path: '/',domain: '.socialpsychology.org', secure: true});
			$.removeCookie(this.getHttpCookieName(), {path: '/',domain: '.socialpsychology.org', secure: false});
			
			// if(user && user.profileid)
			// 	window.location = "//"+user.username+"."+window.config.rootdomain+"/";
			// else if(user.member_profileid) {
			// 	window.location = "//www."+window.config.rootdomain+"/member/"+user.username;
			// } else {
			// 	window.location = "//www."+window.config.rootdomain+"/";
			// }
			
		},
		
		validCookies: function() {
			
			return !!this.getHttpCookie() && !!$.cookie(this.getCookieName());
		},

		// Theres a seperate cookie for each instance of the framework
		getCookieName: function() {
			if(window.config.test)
				return "test_"+window.config.rootdomain.replace(/\./g, "_");
			else
				return window.config.rootdomain.replace(/\./g, "_");

		},
		
		getHttpCookieName: function() {
			
			if(window.config.test)
				return "http_"+this.getCookieName();
			else
				return "http_"+this.getCookieName();
		},

		getId: function(https) {
			if(this.get("session"))
				return this.get("session") && this.get("session").split("-")[0];
			else if(!https) {
				var httpCookie = this.getHttpCookie();
				
				if(httpCookie && httpCookie.id)
					return httpCookie.id;
			} else {
				return false;
			}
		},
		
		getHttpCookie: function() {
			try {
				return JSON.parse(sjcl.decrypt("oin3oinooin", $.cookie(this.getHttpCookieName())));
			} catch(e) {
				return;
			}
			
		},

		initialize: function() {
			
			this.set("session", $.cookie(this.getCookieName()));
			
			var cookie = $.cookie(this.getHttpCookieName());
			
			if(cookie && cookie.stayLoggedIn)
				this.set("stayLoggedIn", true);

			//this.on("change:session", this.setUpCookies, this);
		},
		
		// @todo @future use localstorage rather than cookies for the "http cookie".
		updateHttpCookie: function(stayLoggedIn, userModel, c) {
			/**
			*
			* Lets save a http cookie with basic btu encrpyted info.
			*
			**/
			
			// Lets allow the userModel not to be passed in.
			if(!!userModel && !c) {
				c = userModel;
				userModel = null;
			}
			
			var pullData = function() {

				// The server side may set the httpCookie, but this client side will update it.
				var sensitiveInfo = JSON.stringify({
					id: 				userModel.get("id"),
					photoid: 			userModel.get("photoid") || userModel.get("photo_uploadid"),
					firstname: 			userModel.get("firstname"),
					lastname: 			userModel.get("lastname"),
					adminlevel: 		userModel.get("adminlevel"),
					username: 			userModel.get("username"),
					profileid: 			userModel.get("profileid"),
					member_profileid: 	userModel.get("member_profileid"),
					institution: 		userModel.get("institution"),
					orientation: 		userModel.get("orientation"),
					password: 			userModel.get("password"),
					stayLoggedIn: 		stayLoggedIn
				});
				
				var encryptedInfo = sjcl.encrypt("oin3oinooin", sensitiveInfo);
				
				var http_options = {
					path: '/',
					domain: '.socialpsychology.org',
					secure: false
				};
				
				if(stayLoggedIn)
					http_options.expires = 365 * 10;
				
				$.cookie(this.getHttpCookieName(), encryptedInfo, http_options);
				
				if(c) c(userModel);
			
				this.trigger("cookieupdate");
				
			}

			if(!userModel) userModel = new UserModel({userid: this.getId()});
		
			userModel.onReady(_.bind(pullData, this));
			
		},
		
		setUpCookies: function(c) {

			if(this.get("session")) {
				
				/**
				*
				* Lets save the main SSL cookie
				*
				**/
				var options = { 
					path: '/',
					domain: '.socialpsychology.org',
					secure: true
				};

				if(this.get("stayLoggedIn"))
					options.expires = 365 * 10;

				$.cookie(this.getCookieName(), this.get("session"), options);
				
				// Lets remove the old session cookie
				$.removeCookie("spn__ci_session", "", {path: '/',domain: '.socialpsychology.org'});
				
				
				this.updateHttpCookie(this.get("stayLoggedIn"), c);
				
			
			} else {

				//$.removeCookie(this.getCookieName());
				c();

			}

		},

		login: function(username, password, stayLoggedIn, callback) {
			
			// Lets try to get a visitor id.
			var visitorId;
			_paq.push([ function() { visitorId = this.getVisitorId(); }]);
			
			this.save({username: username, password: password, visitorId: visitorId, stayLoggedIn: stayLoggedIn}, {	
				success: _.bind(function(model, json) {
					this.setUpCookies(function(userModel) {
						callback(model, json, userModel);
					});
				
				}, this)
			});

		}

	});

});